'use client';
import { useMutation, useQuery, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { USER_QUERIES } from '../../infrastructure/user/utils/queries';

type UseGetUserMeOptions = {
  enabled?: boolean;
};

export const useUserService = () => {
  const useGetUserMe = ({ enabled = true }: UseGetUserMeOptions = {}) => {
    return useQuery({
      ...USER_QUERIES.getMe(),
      enabled,
    });
  };

  const useGetUserMeSuspense = () => {
    return useSuspenseQuery(USER_QUERIES.getMe());
  };

  return {
    useGetUserMe,
    useGetUserMeSuspense,
  };
};

export const useUserMutation = () => {
  const useConfirmGuest = () => useMutation(USER_QUERIES.confirmGuest());
  const useGetUserMeMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(USER_QUERIES.getMeMutation(queryClient));
  };

  const useUpdateUserMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(USER_QUERIES.updateUserMutation(queryClient));
  };

  return {
    useGetUserMeMutation,
    useConfirmGuest,
    useUpdateUserMutation,
  };
};
